module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAAEhcmxxAAAAAXNSR0IArs4c6QAAAM1JREFUKBV1kT0KwlAQhFeFWFilsRDxAjZptEojCB7b3mto4QXSRATnCzuP+Lcwyb6Znd19SURELZQ4laydZArVkVdJbH1okwgS1GqWyVHvq/AUEDdCCQiaul/QsPRSPs+CQVBeAkc95SHYAXkQOi9sYSHyLPQ4iIsAyW16IRBsp5Kw+33FFBpmsO5aoA0th1Z6O1h/JzDq5qUYs0/SRh2/uN4GRGJs5Gxzmco3d4yLKXwIrLEU7gL/I5jwWTi+xy9t+OJcHPFfcPFGWL0AoEck64rgdIEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_cancel2.png
// module id = QXIn
// module chunks = 1